var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',{staticClass:"form-control",attrs:{"value":_vm.value,"options":Object.assign({}, {prefix: _vm.prefix},
    _vm.number),"raw":true,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.input},nativeOn:{"blur":function($event){return _vm.blur.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }